import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=c6ae6754&scoped=true&"
import script from "./EmployeeCard.vue?vue&type=script&lang=js&"
export * from "./EmployeeCard.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeCard.vue?vue&type=style&index=0&id=c6ae6754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ae6754",
  null
  
)

export default component.exports